module.exports = __webpack_public_path__ + "img/demetrio-strimpopulos.785da609.png";